<template>
    <input type="range" :id="id" :min="min" :max="max" :step="step" :value="value">
</template>

<script>
import rangeSlider from 'rangeslider-pure'

const id = 'slider-' + Math.random()
let sliderHandle = null
let slider = null

export default {
    name: 'CustomRange',
    props: ['min', 'max', 'step', 'value'],
    data () {
        return {
            id
        }
    },
    methods: {
        init () {
            let self = this
            slider = document.getElementById(id)
            if (slider.rangeSlider) slider.rangeSlider.destroy()
            rangeSlider.create(slider, {
                vertical: true,
                onInit () {
                    sliderHandle = document.querySelector('.rangeSlider__handle')
                    sliderHandle.ontouchstart = (e) => e.preventDefault()
                    sliderHandle.ontouchmove = (e) => e.preventDefault()
                },
                onSlideEnd (position) {
                    self.$emit('input', position)
                }
            })
        }
    },
    watch: {
        value (value) {
            slider.rangeSlider.update({ value })
        }
    },
    mounted () {
        setTimeout(this.init)
    },
    beforeDestroy () {
        slider.rangeSlider.destroy()
        sliderHandle.ontouchstart = null
        sliderHandle.ontouchmovel = null
    }
}
</script>

<style>
    @import '../../../../node_modules/rangeslider-pure/dist/range-slider.css';

    .rangeSlider__handle__vertical {
        background-color: #2fc2ef;
        height: 27px;
        width: 27px;
        left: -12px;
        border: 2px solid #fff;
    }

    .rangeSlider__handle__vertical:after {
        display: none;
    }

    .rangeSlider__fill__vertical {
        width: 4px;
        background-color: #23b8dc;
    }

    .rangeSlider__vertical {
        width: 0;
    }

    .rangeSlider__vertical:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        border-right: 3px dotted #ccc;
    }
</style>
